import React from 'react';
import css from './VerifyAddressModal.module.scss';
import Button from '../../../../components/UI/Button';

export default function VerifyAddressModal({
  suggestedAddress,
  enteredAddress,
  submitAddress,
  closeModal,
  loading
}) {
  return (
    <div className={css.modalBackground}>
      <div className={css.modal}>
        <button
          className={css.closeButton}
          onClick={closeModal}
          data-testid="modal-close-button"
        >
          <img src="/static/x-icon.svg" alt="Close modal" />
        </button>
        {suggestedAddress ? (
          <>
            <p>Did you mean?</p>
            <p className={css.addressType}>Suggested address:</p>
            <p>
              {suggestedAddress.address} {suggestedAddress.address2}
              <br />
              {suggestedAddress.city}, {suggestedAddress.state}{' '}
              {suggestedAddress.zip}
            </p>
            <p className={css.addressType}>Entered address:</p>
            <p>
              {enteredAddress.address} {enteredAddress.address2}
              <br />
              {enteredAddress.city}, {enteredAddress.state} {enteredAddress.zip}
            </p>
            <p>Using the suggested address ensures card delivery.</p>
            <Button
              data-testid="option"
              text="Yes, use suggested address"
              onClick={() => submitAddress({ useSuggestedAddress: true })}
              loading={loading}
            />
            <Button
              data-testid="secondary-option"
              text="No, use address I entered"
              onClick={() => submitAddress({ useSuggestedAddress: false })}
              secondary={true}
              loading={loading}
            />
          </>
        ) : (
          <>
            <p>Unable to verify address</p>
            <p>
              We weren't able to verify the address you provided. Please confirm
              your permanent U.S. residential address to continue. If your
              mailing address is different, you can edit it later in the app.
            </p>
            <Button
              data-testid="option"
              text="Edit address"
              onClick={closeModal}
              loading={loading}
            />
            <Button
              data-testid="secondary-option"
              text="Continue anyways"
              onClick={() => submitAddress({ useSuggestedAddress: false })}
              secondary={true}
              loading={loading}
            />
          </>
        )}
      </div>
    </div>
  );
}
